import { formFieldsValidation } from '../wcl-helpers.js';
import { SendRequest } from '../wcl-helpers.js';



if (document.querySelector('.wcl-log-in-form')) {
    const form = document.querySelector('.wcl-log-in-form');

    // Get variables
    const formInputs = form.querySelectorAll('.data-input');
    const wpnonce = form.querySelector('#wcl_log_in_wpnonce');
    const submitBtn = form.querySelector('.wcl-button');

    // Get UI element
    const message = form.querySelector('.wcl-message');

    submitBtn.addEventListener('click', e => {
        e.preventDefault();

        message.classList.remove('show', 'error', 'success');

        // Validation
        if (formFieldsValidation(formInputs)) {
            return;
        }

        form.classList.add('loading');

        const userEmail = form.querySelector('#user-email');
        const userPassword = form.querySelector('#user-password');

        // Prepare data to request
        const requestArgs = `&wpnonce=${wpnonce.value}&user_email=${userEmail.value}&user_password=${encodeURIComponent(userPassword.value)}`;

        SendRequest('log_in', requestArgs).then(function (res) {
            form.classList.remove('loading');

            let response = JSON.parse(res);

            if (response.success == '1') {
                window.location.href = '/my-account';
            } else {
                throw new Error(response.message);
            }

        }).catch(function (err) {
            // Error
            form.classList.remove('loading');

            message.innerHTML = err;
            message.classList.add('show', 'error');
        });
    });
}